import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const c = axios.create({ baseURL: API });

export function setToken(token) {
  if (token) localStorage.setItem("cd-token", token);
  else localStorage.removeItem("cd-token");
}
c.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cd-token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
c.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("cd-token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const api = {
  dashboard: () => c.get("/dashboard").then((r) => r.data),
  // classes
  listClasses: () => c.get("/classes").then((r) => r.data),
  getClass: (id) => c.get(`/classes/${id}`).then((r) => r.data),
  createClass: (d) => c.post("/classes", d).then((r) => r.data),
  updateClass: (id, d) => c.put(`/classes/${id}`, d).then((r) => r.data),
  duplicateClass: (id) => c.post(`/classes/${id}/duplicate`).then((r) => r.data),
  deleteClass: (id) => c.delete(`/classes/${id}`).then((r) => r.data),
  // schools / groups
  listSchools: (id) => c.get(`/classes/${id}/schools`).then((r) => r.data),
  createSchool: (d) => c.post("/schools", d).then((r) => r.data),
  updateSchool: (id, d) => c.put(`/schools/${id}`, d).then((r) => r.data),
  deleteSchool: (id) => c.delete(`/schools/${id}`).then((r) => r.data),
  listGroups: (id) => c.get(`/classes/${id}/groups`).then((r) => r.data),
  createGroup: (d) => c.post("/groups", d).then((r) => r.data),
  updateGroup: (id, d) => c.put(`/groups/${id}`, d).then((r) => r.data),
  deleteGroup: (id) => c.delete(`/groups/${id}`).then((r) => r.data),
  // students
  listStudents: (id) => c.get(`/classes/${id}/students`).then((r) => r.data),
  getStudent: (id) => c.get(`/students/${id}`).then((r) => r.data),
  bulkStudents: (d) => c.post("/students/bulk", d).then((r) => r.data),
  updateStudent: (id, d) => c.put(`/students/${id}`, d).then((r) => r.data),
  deleteStudent: (id) => c.delete(`/students/${id}`).then((r) => r.data),
  // events
  listEvents: (id) => c.get(`/classes/${id}/events`).then((r) => r.data),
  createEvent: (d) => c.post("/events", d).then((r) => r.data),
  updateEvent: (id, d) => c.put(`/events/${id}`, d).then((r) => r.data),
  duplicateEvent: (id) => c.post(`/events/${id}/duplicate`).then((r) => r.data),
  deleteEvent: (id) => c.delete(`/events/${id}`).then((r) => r.data),
  applyEvent: (d) => c.post("/apply-event", d).then((r) => r.data),
  // rewards
  listRewards: (id) => c.get(`/classes/${id}/rewards`).then((r) => r.data),
  createReward: (d) => c.post("/rewards", d).then((r) => r.data),
  updateReward: (id, d) => c.put(`/rewards/${id}`, d).then((r) => r.data),
  deleteReward: (id) => c.delete(`/rewards/${id}`).then((r) => r.data),
  redeemReward: (d) => c.post("/redeem-reward", d).then((r) => r.data),
  // badges
  listBadges: (id) => c.get(`/classes/${id}/badges`).then((r) => r.data),
  createBadge: (d) => c.post("/badges", d).then((r) => r.data),
  updateBadge: (id, d) => c.put(`/badges/${id}`, d).then((r) => r.data),
  deleteBadge: (id) => c.delete(`/badges/${id}`).then((r) => r.data),
  awardBadge: (d) => c.post("/award-badge", d).then((r) => r.data),
  // attendance
  getAttendance: (id, params) => c.get(`/classes/${id}/attendance`, { params }).then((r) => r.data),
  markAttendance: (d) => c.post("/attendance", d).then((r) => r.data),
  // history / stats
  getHistory: (id, params) => c.get(`/classes/${id}/history`, { params }).then((r) => r.data),
  getStats: (id) => c.get(`/classes/${id}/stats`).then((r) => r.data),
  // medals (project)
  listMedals: (id) => c.get(`/classes/${id}/medals`).then((r) => r.data),
  createMedal: (d) => c.post("/medals", d).then((r) => r.data),
  updateMedal: (id, d) => c.put(`/medals/${id}`, d).then((r) => r.data),
  deleteMedal: (id) => c.delete(`/medals/${id}`).then((r) => r.data),
  awardMedal: (d) => c.post("/award-medal", d).then((r) => r.data),
  addComment: (id, d) => c.post(`/students/${id}/comment`, d).then((r) => r.data),
  archiveClass: (id, archived) => c.post(`/classes/${id}/archive`, { archived }).then((r) => r.data),
  regenerateCode: (id) => c.post(`/classes/${id}/regenerate-code`).then((r) => r.data),
  addStudentToGroup: (gid, student_id) => c.post(`/groups/${gid}/add-student`, { student_id }).then((r) => r.data),
  removeStudentFromGroup: (gid, student_id) => c.post(`/groups/${gid}/remove-student`, { student_id }).then((r) => r.data),
  // auth
  login: (username, password) => c.post("/auth/login", { username, password }).then((r) => r.data),
  me: () => c.get("/auth/me").then((r) => r.data),
  // admin
  listTeachers: () => c.get("/admin/teachers").then((r) => r.data),
  createTeacher: (d) => c.post("/admin/teachers", d).then((r) => r.data),
  updateTeacher: (id, d) => c.put(`/admin/teachers/${id}`, d).then((r) => r.data),
  deleteTeacher: (id) => c.delete(`/admin/teachers/${id}`).then((r) => r.data),
  // avatar catalog (admin)
  listAssets: () => c.get("/avatar-assets").then((r) => r.data),
  createAsset: (d) => c.post("/admin/avatar-assets", d).then((r) => r.data),
  updateAsset: (id, d) => c.put(`/admin/avatar-assets/${id}`, d).then((r) => r.data),
  deleteAsset: (id) => c.delete(`/admin/avatar-assets/${id}`).then((r) => r.data),
  listAccessories: () => c.get("/accessories").then((r) => r.data),
  createAccessory: (d) => c.post("/admin/accessories", d).then((r) => r.data),
  updateAccessory: (id, d) => c.put(`/admin/accessories/${id}`, d).then((r) => r.data),
  deleteAccessory: (id) => c.delete(`/admin/accessories/${id}`).then((r) => r.data),
  resetProgress: (id) => c.post(`/classes/${id}/progress/reset`).then((r) => r.data),
  listTeachersBasic: () => c.get("/teachers").then((r) => r.data),
  getDefaults: () => c.get("/admin/defaults").then((r) => r.data),
  saveDefaults: (d) => c.put("/admin/defaults", d).then((r) => r.data),
  applyDefaults: (d) => c.post("/admin/apply-defaults", d).then((r) => r.data),
  resetClassToDefaults: (id, opts) => c.post(`/classes/${id}/reset-to-defaults`, opts || {}).then((r) => r.data),
  copyConfigFrom: (id, d) => c.post(`/classes/${id}/copy-config-from`, d).then((r) => r.data),
  setClassOwner: (id, owner_id) => c.post(`/admin/classes/${id}/owner`, { owner_id }).then((r) => r.data),
  addCollaborator: (id, teacher_id) => c.post(`/classes/${id}/collaborators`, { teacher_id }).then((r) => r.data),
  removeCollaborator: (id, teacher_id) => c.delete(`/classes/${id}/collaborators/${teacher_id}`).then((r) => r.data),
  createProgressBar: (id, d) => c.post(`/classes/${id}/progress-bars`, d).then((r) => r.data),
  updateProgressBar: (id, bid, d) => c.put(`/classes/${id}/progress-bars/${bid}`, d).then((r) => r.data),
  deleteProgressBar: (id, bid) => c.delete(`/classes/${id}/progress-bars/${bid}`).then((r) => r.data),
};

export const portal = {
  classes: () => axios.get(`${API}/portal/classes`).then((r) => r.data),
  assets: () => axios.get(`${API}/portal/avatar-assets`).then((r) => r.data),
  accessories: () => axios.get(`${API}/portal/accessories`).then((r) => r.data),
  classByCode: (code) => axios.get(`${API}/portal/class/by-code/${code}`).then((r) => r.data),
  classStudents: (cid) => axios.get(`${API}/portal/class/${cid}/students`).then((r) => r.data),
  student: (sid) => axios.get(`${API}/portal/student/${sid}`).then((r) => r.data),
  updateAvatar: (sid, customization) => axios.put(`${API}/portal/student/${sid}/avatar`, { customization }).then((r) => r.data),
  purchase: (sid, item_id, kind) => axios.post(`${API}/portal/student/${sid}/purchase`, { item_id, kind }).then((r) => r.data),
};

Object.assign(api, {
  resetStudent: (id, opts) => c.post(`/students/${id}/reset`, opts || {}).then((r) => r.data),
  removeMedal: (id, medal_id) => c.post(`/students/${id}/remove-medal`, { medal_id }).then((r) => r.data),
  removeBadge: (id, badge_id) => c.post(`/students/${id}/remove-badge`, { badge_id }).then((r) => r.data),
  listRankCollections: () => c.get("/rank-collections").then((r) => r.data),
  createRankCollection: (name) => c.post("/admin/rank-collections", { name }).then((r) => r.data),
  deleteRankCollection: (id) => c.delete(`/admin/rank-collections/${id}`).then((r) => r.data),
  createRank: (d) => c.post("/admin/ranks", d).then((r) => r.data),
  updateRank: (id, d) => c.put(`/admin/ranks/${id}`, d).then((r) => r.data),
  deleteRank: (id) => c.delete(`/admin/ranks/${id}`).then((r) => r.data),
  reorderRanks: (ids) => c.post("/admin/ranks/reorder", { ids }).then((r) => r.data),
  undoHistory: (hid) => c.post(`/history/${hid}/undo`).then((r) => r.data),
  adjustPoints: (id, d) => c.post(`/classes/${id}/adjust-points`, d).then((r) => r.data),
  reorder: (kind, ids) => c.post(`/reorder/${kind}`, { ids }).then((r) => r.data),
});
